<template>
  <div
    class="account-settings"
    :class="{'mt-custom-75': !isMobile}"
  >
    <account-settings-menu />
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AccountSettingsMenu from './AccountSettings/AccountSettingsMenu';


export default {
  components: {
    AccountSettingsMenu,
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/AccountSettings.vue